import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import moment from 'moment';
import { DATE_FORMAT } from 'app/shared/constants/input.constants';
import { map } from 'rxjs/operators';

import { createRequestOption } from 'app/shared/util/request-util';
import { ICardInfoRx } from 'app/shared/model/card-info-rx.model';
import AppConfigService from 'app/core/app-config.service';

type EntityResponseType = HttpResponse<ICardInfoRx>;
type EntityArrayResponseType = HttpResponse<ICardInfoRx[]>;

@Injectable({ providedIn: 'root' })
export default class CardInfoRxService {
  public resourceUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/card-infos`;

  constructor(protected http: HttpClient) {}

  getCardList(data): Observable<any> {
    const requestUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/${data}/card`;
    return this.http.get(requestUrl);
  }

  addCardPayment(transPresData: any, data): Observable<any> {
    const addCardPaymentUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/${data}/addCard`;
    return this.http.post(addCardPaymentUrl, transPresData);
  }

  deleteCardPayment(tranData: any, idData): Observable<any> {
    const deleteCardPaymentUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/${idData}/deactivateCard`;
    return this.http.post(deleteCardPaymentUrl, tranData, { responseType: 'text' });
  }

  updateCardInfo(transferData: any, patientIdData, facilityIdData): Observable<any> {
    const updateCardPaymentUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/${patientIdData}/update`;
    const param = new HttpParams().set('facilityId', facilityIdData);
    return this.http.put(updateCardPaymentUrl, transferData, { params: param, responseType: 'text' });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<ICardInfoRx>(`${this.resourceUrl}/${id}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  protected convertDateFromClient(cardInfo: ICardInfoRx): ICardInfoRx {
    const copy: ICardInfoRx = { ...cardInfo, expiryDate: cardInfo.expiryDate != null && cardInfo.expiryDate.isValid() ? moment(cardInfo.expiryDate.format(DATE_FORMAT)) : null };
    return copy;
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      res.body.expiryDate = res.body.expiryDate != null ? moment(res.body.expiryDate) : null;
    }
    return res;
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((cardInfo: ICardInfoRx) => {
        cardInfo.expiryDate = cardInfo.expiryDate != null ? moment(cardInfo.expiryDate) : null;
      });
    }
    return res;
  }
}
